import React from "react";
import { Link } from "react-router-dom";
import { startCase, upperCase } from "lodash-es";
import { Tag } from "antd";
import { InventoryTransfer } from "../../../api/transfer";
import moment from "moment";

export const statusColor: Record<string, string> = {
  requested: "green",
  processing: "orange",
  completed: "blue",
  cancelled: "red",
};
export const generateSerial = (id: string) => id.slice(-12).toUpperCase();

export const getColumns = (orgId: string) => [
  {
    title: "Transfer ID",
    dataIndex: "id",
    key: "id",
    render(id: string, data: InventoryTransfer) {
      return <Link to={`/organizations/${orgId}/transfers/${id}`}>{generateSerial(id.toString())}</Link>;
    },
  },
  {
    title: "Status",
    dataIndex: "status",
    key: "status",
    render(status: string) {
      return <Tag color={statusColor[status]}>{startCase(status)}</Tag>;
    },
  },
  {
    title: "Origin Facility",
    dataIndex: "from_facility",
    key: "from_facility",
    render: upperCase,
  },
  {
    title: "Destination Facility",
    dataIndex: "to_facility",
    key: "to_facility",
    render: upperCase,
  },
  {
    title: "Created At",
    dataIndex: "created_at",
    key: "created_at",
    render(date: string) {
      return moment(date).format("LLL");
    },
  },
];
